import { createResource } from "./resourceFactory"
import { ConfigResponse } from "@/types/config"
import { FALLBACK_STRINGS } from "@/fallback/config"

const configResource = createResource<ConfigResponse>("/config2", {
  resourceName: "config",
})

/**
 * Endpoint to get configuration
 * @returns Response with configuration strings for the UI
 */
export const getConfig = async (): Promise<Record<string, string>> => {
  try {
    const result = await configResource.get()
    return result.strings
  } catch (error) {
    // The error is already handled by the resource factory
    // but we return the default response here as a fallback
    console.error(`getConfig error: ${error}`)
    return FALLBACK_STRINGS
  }
}
